import { useRegions, useProvinces, useCitiesMunis, useBarangays } from '@/hooks/usePsgcCascade'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { Label } from '@/components/ui/label'

interface PsgcCascadeProps {
  regionPsgc: string | null
  provincePsgc: string | null
  cityMuniPsgc: string | null
  barangayPsgc: string | null
  onRegionChange: (v: string) => void
  onProvinceChange: (v: string) => void
  onCityMuniChange: (v: string) => void
  onBarangayChange: (v: string) => void
}

export function PsgcCascade({
  regionPsgc, provincePsgc, cityMuniPsgc, barangayPsgc,
  onRegionChange, onProvinceChange, onCityMuniChange, onBarangayChange,
}: PsgcCascadeProps) {
  const { data: regions, isLoading: regionsLoading } = useRegions()
  const { data: provinces, isLoading: provincesLoading } = useProvinces(regionPsgc)
  const { data: cities, isLoading: citiesLoading } = useCitiesMunis(provincePsgc)
  const { data: barangays, isLoading: barangaysLoading } = useBarangays(cityMuniPsgc)

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label>Region</Label>
        <Select value={regionPsgc ?? ''} onValueChange={onRegionChange} disabled={regionsLoading}>
          <SelectTrigger>
            <SelectValue placeholder={regionsLoading ? 'Loading...' : 'Select region'} />
          </SelectTrigger>
          <SelectContent>
            {regions?.map((r) => (
              <SelectItem key={r.psgc_code} value={r.psgc_code}>{r.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label>Province</Label>
        <Select value={provincePsgc ?? ''} onValueChange={onProvinceChange} disabled={!regionPsgc || provincesLoading}>
          <SelectTrigger>
            <SelectValue placeholder={provincesLoading ? 'Loading...' : 'Select province'} />
          </SelectTrigger>
          <SelectContent>
            {provinces?.map((p) => (
              <SelectItem key={p.psgc_code} value={p.psgc_code}>{p.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label>City / Municipality</Label>
        <Select value={cityMuniPsgc ?? ''} onValueChange={onCityMuniChange} disabled={!provincePsgc || citiesLoading}>
          <SelectTrigger>
            <SelectValue placeholder={citiesLoading ? 'Loading...' : 'Select city/municipality'} />
          </SelectTrigger>
          <SelectContent>
            {cities?.map((c) => (
              <SelectItem key={c.psgc_code} value={c.psgc_code}>{c.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label>Barangay</Label>
        <Select value={barangayPsgc ?? ''} onValueChange={onBarangayChange} disabled={!cityMuniPsgc || barangaysLoading}>
          <SelectTrigger>
            <SelectValue placeholder={barangaysLoading ? 'Loading...' : 'Select barangay'} />
          </SelectTrigger>
          <SelectContent>
            {barangays?.map((b) => (
              <SelectItem key={b.psgc_code} value={b.psgc_code}>{b.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  )
}
